export default "__VITE_ASSET__C1PGAkBb__"